class CartCount extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      window.addEventListener("cart:changed", this.update.bind(this));
      window.addEventListener("cart:add", this.increment.bind(this));
    }
    update(e) {
      if (typeof e.detail?.item_count !== 'number') return;
      this.innerHTML = `${e.detail.item_count}`;
      this.hidden = e.detail.item_count === 0;
    }
    increment(e) {
      if (!e.detail.added_count) return;
      this.innerHTML = `${parseInt(this.innerHTML) + e.detail.added_count}`;
      this.hidden = false;
    }
  }
  customElements.define("cart-count", CartCount);


  class CartDrawer extends Popup {
    constructor() {
      super();
    }
    connectedCallback() {
      super.connectedCallback();
      window.addEventListener("cart:add", this.open.bind(this));
  
      this.updateLineItemsHeight();
    }
    open(e) {
      if (typeof AtcSuccessModal !== "undefined" && AtcSuccessModal.matches(e?.detail)) {
        return;
      }
      super.open()
      window.requestAnimationFrame(this.frame.bind(this));
    }
    close() {
      super.close()
    }
    frame() {
      this.updateLineItemsHeight();
      if(super.isOpen()){
        window.requestAnimationFrame(this.frame.bind(this)); 
      }
    }
    // Limits the height of the line item container
    updateLineItemsHeight() {
      const upper = this.querySelector("[data-cart-drawer-upper]")?.getBoundingClientRect().height ?? 0;
      const header = this.querySelector("[data-cart-drawer-header]")?.getBoundingClientRect().height ?? 0;
      const upsell = this.querySelector("[data-cart-drawer-upsell]")?.getBoundingClientRect().height ?? 0;
      const footer = this.querySelector("[data-cart-drawer-footer]")?.getBoundingClientRect().height ?? 0;
      const items = this.querySelector("[data-cart-drawer-items]");
  
      const combinedHeightOfOtherElements = upper + header + footer;
  
      items.style.maxHeight = window.innerHeight - combinedHeightOfOtherElements + "px";
    }
  }
  customElements.define("cart-drawer", CartDrawer);


  class CartForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const quantities = this.querySelectorAll(`[name="updates[]"]`);
      const removeButtons = this.querySelectorAll(`[name="line-item-remove"]`);
  
      quantities.forEach((qty) => {
        qty.addEventListener("change", (e) => {
          this.loading = true;
          this.updateCart({ [qty.dataset.lineItemKey]: Number(qty.value) }).then((res) => {
            this.updateView(res.sections[this.section]);
            this.loading = false;
          });
        });
      });
  
      removeButtons.forEach((rm) => {
        rm.addEventListener("click", (e) => {
          e.preventDefault();
          this.removeByUrl(rm.href);
        });
      });
  
      window.addEventListener("cart:add", (e) => {
        this.loading = true;
        this.updateView(e.detail?.sections[this.section]);
        this.loading = false;
      });
    }
  
    get section() {
      return this.getAttribute("section") || "cart-main";
    }
  
    removeByUrl(href) {
      this.loading = true;
      const url = new URL(href);
      url.searchParams.append("sections", this.section);
      fetch(`${url}`, {
        headers: {
          Accept: "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          window.dispatchEvent(new CustomEvent("cart:changed", { detail: { ...res } }));
          this.updateView(res.sections[this.section]);
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    }
  
    updateView(htmlString) {
      const div = document.createElement("div");
      div.innerHTML = htmlString.trim();
      const newForm = div.querySelector("cart-form");
      this.replaceWith(newForm);
      window.dispatchEvent(new CustomEvent("cart:updated"));
      console.log("Cart updated");
    }
  
    async updateCart(updates) {
      return new Promise((resolve) => {
        Shopify.theme.cart.updateCart({ updates }, true, resolve);
      });
    }
    set loading(v) {
      if (v) {
        this.setAttribute("loading", v);
      } else {
        this.removeAttribute("loading");
      }
    }
    get loading() {
      return this.hasAttribute("loading");
    }
  
    static get observedAttributes() {
      return [];
    }
    attributeChangedCallback(property, oldValue, newValue) {
      if (oldValue === newValue) return;
      this[property] = newValue;
    }
  }
  customElements.define("cart-form", CartForm);

